import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Api_Url } from '../../config/config'
import axios from 'axios'
import { Button, Divider, Modal, Table } from 'antd'
import toast from 'react-hot-toast'
import { ErrorToast, SuccessToast, UpdatedToast } from '../../views/ToastComponent'

function FlourMillDataDetails() {
  const { id } = useParams()

  const [singleData, setSingleData] = useState([])
  const [EditDataId, setEditDataId] = useState(0); // initial will 0 
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);

  const getSingleUser = async () => {
    try {
      const response = await axios.get(`${Api_Url}api/v1/FlourMill/item/getbyflourmillid/${id}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
        }
      })
      setSingleData(response.data.data)
    } catch (error) {
      return error.message
    }
  }

  useEffect(() => {
    getSingleUser()
  }, [])

  const [flourMillData, setFlourMillData] = useState({
    name: '',
    timeConsuming: 0,
    dailyGrind: 0,
    grindPrice: 0,
    dailyRunningHours: 0,
    grossIncome: 0,
    flourMillId: id,
    latitude: '',
    longitude: ''
  })

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {

        const { latitude, longitude } = position.coords;
        setFlourMillData({ ...flourMillData, latitude: latitude.toString(), longitude: longitude.toString() });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, [])

  const handleSubmit = async (operationType) => {

    try {

      let response;
      if (operationType == "Submit") {
        response = await axios.post(`${Api_Url}api/v1/FlourMill/item`, flourMillData, {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
          }
        })
        if (response.data?.succeeded) {
          SuccessToast("Added successfully")
          getSingleUser()
          handleCancel()
        }
      } else {
        const data = {
          ...flourMillData,
          id: EditDataId
        }
        response = await axios.post(`${Api_Url}api/v1/FlourMill/item/${EditDataId}`, data, {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
          }
        })
        if (response.data?.succeeded) {
          UpdatedToast("Updated successfully")
          getSingleUser()
          handleCancel()
        }
      }
    } catch (error) {
      ErrorToast("Something went wrong")
      console.log(error)
    }

  }

  async function handleCancel() {
    setFlourMillData({
      ...flourMillData,
      name: '',
      timeConsuming: 0,
      dailyGrind: 0,
      grindPrice: 0,
      dailyRunningHours: 0,
      grossIncome: 0,
      flourMillId: id,
    })

    setEditDataId(0); // reset form with initial value 0
    setIsModalOpen(false);
  }



  const calculateMonthlyRevenue = () => {
    const result = (flourMillData.timeConsuming * flourMillData.dailyGrind)
    setFlourMillData(prev => ({
      ...prev,
      dailyRunningHours: result / 60
    }))
  };

  const calculatePerMonth = () => {
    const result = flourMillData.grindPrice * flourMillData.dailyGrind
    setFlourMillData(prev => ({
      ...prev,
      grossIncome: result
    }))
  };

  //   React.useEffect(() => { fetchIncomeData(); fetchAreaType(); fetchCurentLocation(); }, []);

  React.useEffect(() => {
    calculateMonthlyRevenue();
  }, [flourMillData.grindPrice, flourMillData.dailyGrind]);

  React.useEffect(() => {
    calculatePerMonth();
  }, [flourMillData.grindPrice, flourMillData.dailyGrind]);


  const handleClick = async (id) => {

    setEditDataId(id)
    setIsModalOpen(true)

  }

  async function LoadSingleFlourMill(hereId) {
    try {
      const response = await axios.get(`${Api_Url}api/v1/FlourMill/item/${hereId}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
        }
      })
      setFlourMillData({
        ...flourMillData,
        name: response.data.data.name,
        timeConsuming: response.data.data.timeConsuming,
        dailyGrind: response.data.data.dailyGrind,
        grindPrice: response.data.data.grindPrice,
        dailyRunningHours: response.data.data.dailyRunningHours,
      })
    } catch (e) {
      console.log("Load Single Flour Mill", e.message)
    }
  }

  useEffect(() => {
    if (EditDataId !== 0) {

      LoadSingleFlourMill(EditDataId)
    }
  }, [EditDataId !== 0])

  //update Method

  const columns = [
    {
      title: "Product",
      dataIndex: "name",
      // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
    },
    {
      title: "Time Consuming",
      dataIndex: "timeConsuming",
      // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
    },
    {
      title: "Daily Grind",
      dataIndex: "dailyGrind",
      // sorter: (a, b) => a.dailyGrind.length - b.dailyGrind.length,
    },
    {
      title: "Grind Price",
      dataIndex: "grindPrice",
      // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
    },
    {
      title: "Running Hrs",
      dataIndex: "dailyRunningHours",
      // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
    },
    {
      title: "Gross Income",
      dataIndex: "grossIncome",
      // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
    },
    {
      title: 'Edit',
      dataIndex: 'edit',
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => handleClick(record.id)}
            style={{ marginLeft: '10px' }}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
    // {
    //   title: 'Delete',
    //   dataIndex: 'delete',
    //   // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
    //   render: (text, record) => (
    //     <div>
    //       {text}
    //       <Button
    //        className='btn btn-danger'
    //         type="primary"
    //         // onClick={() => handleClick(record.id)}
    //         style={{ marginLeft: '10px' }}
    //       >
    //       <i class="fa-solid fa-trash"></i>
    //       </Button>
    //     </div>
    //   ),
    // },
  ];


  return (

    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h3 className="mb-0">Flour Mill</h3>
              <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsModalOpen(true)}>Add flour mill</button>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12 mx-auto">
              <Table
                className="table-striped"
                style={{ overflowX: "auto" }}
                columns={columns}
                dataSource={singleData}
                rowKey={(record) => record.id}
              />
            </div>
          </div>
        </div>
      </div>
            //add Modal

      <Modal
        title={<h4>{EditDataId == 0 ? "Add" : "Edit"} Flour Mill</h4>}
        open={isModalOpen}

        onOk={() => setIsModalOpen(false)}
        onCancel={() => handleCancel()}
        footer={[
          <div className='d-flex justify-content-between align-items-center'>
            <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
            <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleSubmit(EditDataId == 0 ? "Submit" : "Edit")}>{EditDataId == 0 ? "Submit" : "Update"}</button>
          </div>
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: 'red' }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <Divider>Flour Mill Information</Divider>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Product Name
                  </label>
                  <input className="form-control" type="text" placeholder="Enter PRoduct Name" value={flourMillData.name} onChange={(e) => setFlourMillData({ ...flourMillData, name: e.target.value })} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Time (Min) Consumption/Kg:
                  </label>
                  <input className="form-control" type="number" placeholder="Enter Taking Time in minute" value={flourMillData.timeConsuming} onChange={(e) => setFlourMillData({ ...flourMillData, timeConsuming: e.target.value })} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Daily Grind/Kg
                  </label>
                  <input className="form-control" type="text" placeholder="Enter Daily Grind In kg" value={flourMillData.dailyGrind} onChange={(e) => setFlourMillData({ ...flourMillData, dailyGrind: e.target.value })} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Grind Price/Kg:
                  </label>
                  <input className="form-control" type="number" placeholder="Enter Grind Price" value={flourMillData.grindPrice} onChange={(e) => setFlourMillData({ ...flourMillData, grindPrice: e.target.value })} />
                </div>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Daily Running hours: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {flourMillData.dailyRunningHours.toFixed(2)}</span>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Gross Income - Daily: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {flourMillData.grossIncome.toFixed(2)}</span>
              </div>
            </div>
          </form>
        </div>
      </Modal>

    </>
  )
}

export default FlourMillDataDetails
